// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_Awv","cls2":"Comments-cls2_EYP Comments-cls1_Awv"};